var _a, _b, _c, _d, _e;
import { generateActions } from "../generators/generator.actions";
import { EActionState, createCustomAction } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./bankAccount.constants";
export var getCountStart = (_a = generateActions(GENERATOR_PARAMS), _a.getCountStart), getCountSucceeded = _a.getCountSucceeded, getCountFailed = _a.getCountFailed, getDetailStart = _a.getDetailStart, getDetailSucceeded = _a.getDetailSucceeded, getDetailFailed = _a.getDetailFailed;
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["RemoveBankAccount"] = "REMOVE_BANK_ACCOUNT";
    EActionCustom["UpdateBankAccountOwnerName"] = "UPDATE_BANK_ACCOUNT_OWNER_NAME";
    EActionCustom["GetContactBankAccounts"] = "GET_CONTACT_BANK_ACCOUNTS";
    EActionCustom["CreateContactBankAccount"] = "CREATE_CONTACT_BANK_ACCOUNT";
})(EActionCustom || (EActionCustom = {}));
var generateRemoveBankAccountActions = function () { return ({
    removeBankAccountStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemoveBankAccount,
        state: EActionState.Start,
    }),
    removeBankAccountSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemoveBankAccount,
        state: EActionState.Success,
    }),
    removeBankAccountFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemoveBankAccount,
        state: EActionState.Fail,
    }),
}); };
export var removeBankAccountStart = (_b = generateRemoveBankAccountActions(), _b.removeBankAccountStart), removeBankAccountSucceeded = _b.removeBankAccountSucceeded, removeBankAccountFailed = _b.removeBankAccountFailed;
var generateUpdateBankAccountOwnerNameActions = function () { return ({
    updateBankAccountOwnerNameStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdateBankAccountOwnerName,
        state: EActionState.Start,
    }),
    updateBankAccountOwnerNameSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdateBankAccountOwnerName,
        state: EActionState.Success,
    }),
    updateBankAccountOwnerNameFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdateBankAccountOwnerName,
        state: EActionState.Fail,
    }),
}); };
export var updateBankAccountOwnerNameStart = (_c = generateUpdateBankAccountOwnerNameActions(), _c.updateBankAccountOwnerNameStart), updateBankAccountOwnerNameSucceeded = _c.updateBankAccountOwnerNameSucceeded, updateBankAccountOwnerNameFailed = _c.updateBankAccountOwnerNameFailed;
var generateGetContactBankAccountsActions = function () { return ({
    getContactBankAccountsStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetContactBankAccounts,
        state: EActionState.Start,
    }),
    getContactBankAccountsSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetContactBankAccounts,
        state: EActionState.Success,
    }),
    getContactBankAccountsFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetContactBankAccounts,
        state: EActionState.Fail,
    }),
}); };
export var getContactBankAccountsStart = (_d = generateGetContactBankAccountsActions(), _d.getContactBankAccountsStart), getContactBankAccountsSucceeded = _d.getContactBankAccountsSucceeded, getContactBankAccountsFailed = _d.getContactBankAccountsFailed;
var generateCreateContactBankAccountActions = function () { return ({
    createContactBankAccountStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreateContactBankAccount,
        state: EActionState.Start,
    }),
    createContactBankAccountSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreateContactBankAccount,
        state: EActionState.Success,
    }),
    createContactBankAccountFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreateContactBankAccount,
        state: EActionState.Fail,
    }),
}); };
export var createContactBankAccountStart = (_e = generateCreateContactBankAccountActions(), _e.createContactBankAccountStart), createContactBankAccountSucceeded = _e.createContactBankAccountSucceeded, createContactBankAccountFailed = _e.createContactBankAccountFailed;
